import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = process.env.REACT_APP_BASE_URL || 'https://roshi-chat.herokuapp.com' 


export const updateType = async (id, type = 'COACH') => {
    return await axios.put(URL + `/admin/user/update/${id}`, {
        type
    })
}